import gql from 'graphql-tag';
import { SURVEY_TYPE } from './SurveyType.gql';

export const SURVEY_TYPE_CONNECTION = gql`
  ${SURVEY_TYPE}
  fragment SurveyTypeConnection on SurveyTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...SurveyType
      }
    }
    totalCount
    edgeCount
  }
`;
